import { FloatingContext, useTransitionStatus } from "@floating-ui/react";
import { CSSProperties } from "react";

const CLOSE_MS = 100;

/**
 * How Rye's floating menus open and close: they fade and grow in from the
 * control they belong to, and fade out a little faster. Render the menu while
 * `isMounted` (it stays mounted through the closing fade), and apply `styles`
 * and `className` to an element inside the floating one, whose own transform
 * positions it.
 *
 * Opening is a CSS animation, which starts by itself as the menu appears,
 * rather than Floating UI's transition styles, which wait a frame to switch
 * from the starting look to the open one.
 */
export function useRyeMenuTransition(context: FloatingContext): {
  isMounted: boolean;
  styles: CSSProperties;
  className: string;
} {
  const { isMounted, status } = useTransitionStatus(context, {
    duration: { close: CLOSE_MS },
  });
  const transformOrigin = context.placement.startsWith("top")
    ? "bottom"
    : "top";
  const closing = status === "close";
  return {
    isMounted,
    styles: closing
      ? {
          transformOrigin,
          opacity: 0,
          transform: "scale(0.97)",
          transition: `opacity ${CLOSE_MS}ms, transform ${CLOSE_MS}ms`,
        }
      : { transformOrigin },
    className: closing ? "" : "animate-menu-in",
  };
}
